import React, { useState } from 'react';

const data = [
  {
    id: 0,
    title: 'GroeiGids BV FY25-26',
    fileUrl: 'https://assets.bharatrohan.in/companies/GroeiGids_BV_FY_25-26.pdf',
    company: 'GroeiGids BV',
  },
];

// Group items by company
const groupByCompany = (items: typeof data) => {
  return items.reduce((acc, item) => {
    acc[item.company] = acc[item.company] || [];
    acc[item.company].push(item);
    return acc;
  }, {} as Record<string, typeof data>);
};

export default function Group() {
  const [selected, setSelected] = useState<number | null>(null);
  const groupedData = groupByCompany(data);

  return (
    <div className="py-8 lg:pb-10">
      <div className="flex flex-col lg:flex-row items-start gap-x-12 xl:gap-x-16 2xl:gap-x-20 gap-y-6 md:gap-y-12 w-full">
        <div className="grid w-full blade-top-padding-sm lg:pt-0 lg:w-[100%] gap-y-8 flex-col">
          {Object.entries(groupedData).map(([company, meetings]) => (
            <div key={company}>
              <h2 className="text-2xl font-bold mb-4 text-green-700">{company}</h2>
              <div className="flex flex-col gap-y-4">
                {meetings.map((item, index) => (
                  <div key={item.id}>
                    <div className="md:w-[70%] sm:w-2">
                      <div
                        onClick={() => setSelected(item.id)}
                        className={`flex w-full py-4 border px-4 sm:px-6 md:px-8 lg:px-4 xl:px-6 border-green items-center justify-between cursor-pointer transition-all duration-300 ${
                          selected === item.id ? 'bg-transparent cursor-auto pt-6' : 'bg-transparent'
                        }`}
                      >
                        <a
                          href={item.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="grid w-full grid-cols-[2.5rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] xl:grid-cols-[4rem_1fr_auto]"
                        >
                          <span className="text-lg lg:text-xl 2xl:text-xl opacity-25 font-bold transition-all duration-300">
                            {`0${item.id + 1}`}
                          </span>
                          <h4 className="text-green font-semibold text-left transition-all duration-300 self-center 2xl:text-xl overflow-hidden">
                          <div
                          className={`inline-block whitespace-nowrap ${item.title.length > 22 ? 'animate-slide 2xl:animate-none' : ''}`} 
                          // style={{ paddingLeft: item.title.length > 10 ? '100%' : 0 }} 
                          >

                          {item.title}
                          </div>
                          </h4>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
